import LimitedEditionWrapper from '@/components/shared/LimitedEditionWrapper';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { Badge, Button } from '@/components/ui/daisy';
import { Breakpoints } from '@/utils/Breakpoint';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useMediaQuery } from 'react-responsive';

type CardAddContentButtonProps = {
  label: string;
  count?: number;
  isLoading?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  isLimitedEdition?: boolean;
};

const CardAddContentButton = ({
  label,
  count = 0,
  isLoading,
  onClick,
  disabled = false,
  isLimitedEdition = false,
}: CardAddContentButtonProps) => {
  const isXl = useMediaQuery({ minWidth: Breakpoints.xl });

  return (
    <LimitedEditionWrapper isLimitedEdition={isLimitedEdition}>
      <ConditionalWrapper
        condition={!isXl && !isLimitedEdition}
        wrapper={<Tooltip text={label} />}
      >
        <Button
          color="primary"
          variant={!count ? 'dash' : 'soft'}
          size="sm"
          onClick={onClick}
          disabled={isLoading || disabled || isLimitedEdition}
        >
          <PlusIcon className="w-4 h-4" />
          {isXl && label}
          <ConditionalRenderer condition={count}>
            <Badge color="primary" size="xs">
              {count}
            </Badge>
          </ConditionalRenderer>
        </Button>
      </ConditionalWrapper>
    </LimitedEditionWrapper>
  );
};

export default CardAddContentButton;
